import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import ItemWithBadgesActions, {
  type ItemWithBadgesActionsProps,
} from '~/components/dashboard/soapV2/collapsibleRail/summary/item-with-badges/ItemWithBadgesActions'
import OrderTooltip from '~/components/dashboard/soapV2/order/OrderTooltip'
import { fetchPrescriptionPrintInfo } from '~/store/actions/orders'
import { getItemErrors } from '~/store/duck/clientFinanceData'
import { useOpenPrescriptionDialogAfterFetchUnifiedOrder } from '~/store/hooks/orders'
import { useDeletePrescription } from '~/store/hooks/prescription'
import type { Order } from '~/types'

export interface PrescriptionItemActionsLineItemProps extends ItemWithBadgesActionsProps {
  isInvoice: boolean
  isLineItem?: boolean
  isRetailOrderLineItem?: boolean
  onDelete?: () => void
  order: Order
}

const PrescriptionItemActionsLineItem = ({
  onDelete: onDeleteProp,
  order,
  isLineItem,
  isInvoice,
  isRetailOrderLineItem,
  ...rest
}: PrescriptionItemActionsLineItemProps) => {
  const dispatch = useDispatch()

  const id = isLineItem ? order.logId : order.id

  const { fetchUnifiedOrderAndOpenPrescription } =
    useOpenPrescriptionDialogAfterFetchUnifiedOrder({
      isChargeSheet: true,
      isInvoice,
    })

  const lineItemErrors = useSelector(getItemErrors)
  const forceDelete =
    lineItemErrors &&
    lineItemErrors.length > 0 &&
    !R.isNil(order) &&
    lineItemErrors.filter((itemError) => itemError.lineItemId === order.id)
      .length > 0

  const handleDelete = useDeletePrescription({
    hasRefills: Boolean(order.refills?.length),
    isFromSoap: Boolean(order.soapId),
    name: order.name,
    retailOrderLineItemLogId: isRetailOrderLineItem
      ? order.logId || undefined
      : undefined,
    order,
    forceDelete,
  })

  const openPrescription = () => {
    if (id) {
      fetchUnifiedOrderAndOpenPrescription(id)
    }
  }

  const handlePrint = () => {
    if (id) {
      dispatch(fetchPrescriptionPrintInfo({ ...order, id }))
    }
  }

  return (
    <ItemWithBadgesActions
      tooltip={
        isRetailOrderLineItem ? null : (
          <OrderTooltip forceShowPrices order={order} />
        )
      }
      onAddRX={openPrescription}
      onDelete={handleDelete}
      onEdit={openPrescription}
      onPrint={handlePrint}
      onView={openPrescription}
      {...rest}
    />
  )
}

export default PrescriptionItemActionsLineItem
